import { LessonLike } from '@/helpers/types/LessonLike';
import { AppliedLessonType } from '@/enums/AppliedLessonType';

function isFunction<T>(value: T | (() => T)): value is () => T {
    return typeof value === 'function';
}

export const resolveLessonTypeByLesson = <Trade, PM, X>(
    lesson: LessonLike,
    resolver: {
        trade: Trade | (() => Trade);
        pm: PM | (() => PM);
        x: X | (() => X);
    }
) => {
    if (lesson.hasOwnProperty('x_sub_process_id')) {
        return isFunction(resolver.x) ? resolver.x() : resolver.x;
    }
    if (lesson.hasOwnProperty('pm_sub_phase_id')) {
        return isFunction(resolver.pm) ? resolver.pm() : resolver.pm;
    }
    return isFunction(resolver.trade) ? resolver.trade() : resolver.trade;
};

export const resolveLessonTypeByAppliedLessonType = <Trade, PM, X>(
    type: AppliedLessonType,
    resolver: {
        trade: Trade | (() => Trade);
        pm: PM | (() => PM);
        x: X | (() => X);
    }
) => {
    if (type === AppliedLessonType.XAppliedLesson) {
        return isFunction(resolver.x) ? resolver.x() : resolver.x;
    }
    if (type === AppliedLessonType.PMAppliedLesson) {
        return isFunction(resolver.pm) ? resolver.pm() : resolver.pm;
    }
    return isFunction(resolver.trade) ? resolver.trade() : resolver.trade;
};
